module.exports = __webpack_public_path__ + "img/home-bg-03.8cd68550.png";